const LUCIDGREEN_URL_PATTERN = /^https?:\/\/(?:www\.)?(?:qr\.lcdg\.io|lucidgreen\.io)\/(.+)$/i;

export function extractLucidId(qrPayload: string): string | null {
  const match = qrPayload.match(LUCIDGREEN_URL_PATTERN);
  return match?.[1] ?? null;
}

export function isLucidGreenUrl(qrPayload: string): boolean {
  return LUCIDGREEN_URL_PATTERN.test(qrPayload);
}
